<template>
    <div>
        <Head :title="`${form.name}`"/>
        <div class="flex justify-start mb-8 max-w-3xl">
            <h1 class="text-3xl font-bold">
                <Link class="text-indigo-400 hover:text-indigo-600" href="/blocker-keyword-response">Blocker Keyword Responses</Link>
                <span class="text-indigo-400 font-medium">/</span>
                {{ form.name }}
            </h1>
        </div>
        <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
            <form @submit.prevent="update">
                <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                    <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2"
                                label="Name"/>
                                
                    <select-input v-model="form.locale" :error="form.errors.locales"  class="pb-8 pr-6 w-full lg:w-1/2" label="Language">
                        <option value="en">EN</option>
                        <option value="de">DE</option>
                    </select-input>
                    <textarea-input v-model="form.text" :rows="20" :error="form.errors.text"  class="pb-8 pr-6 w-full" label="Text"></textarea-input>
                </div>
                <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
                    <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
                        Update Response
                    </loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import {Head, Link} from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import MultipleSelectInput from '@/Shared/MultipleSelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        MultipleSelectInput,
        TextInput,
        TextareaInput
    },
    layout: Layout,
    props: {
        response: Object,
    },
    remember: 'form',
    data() {
        return {
            form: this.$inertia.form({
                name: this.response.name,
                text: this.response.text,
                locale: this.response.locale
            }),
        }
    },
    methods: {
        update() {
            this.form.post(`/blocker-keyword-response/${this.response.id}`)
        }
    },
}
</script>
